import React, { useState } from 'react';
import { Phone, MessageCircle, X } from 'lucide-react';
import { brandInfo } from '../mock';
import { Button } from './ui/button';

export const FloatingActionButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleMenu = () => setIsExpanded(!isExpanded);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3">
      {/* Expanded Menu Items */}
      {isExpanded && (
        <div className="flex flex-col space-y-3 animate-in slide-in-from-bottom-2 fade-in duration-300">
          {/* WhatsApp Button */}
          <Button
            asChild
            className="bg-green-500 hover:bg-green-600 text-white shadow-lg h-12 px-4"
          >
            <a
              href={`https://wa.me/${brandInfo.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2"
            >
              <MessageCircle className="w-5 h-5" />
              <span className="font-medium">WhatsApp</span>
            </a>
          </Button>

          {/* Call Button */}
          <Button
            asChild
            className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg h-12 px-4"
          >
            <a href={`tel:${brandInfo.phones[0]}`} className="flex items-center space-x-2">
              <Phone className="w-5 h-5" />
              <span className="font-medium">Call Now</span>
            </a>
          </Button>
        </div>
      )}

      {/* Main Toggle Button */}
      <button
        onClick={toggleMenu}
        className={`w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 ${
          isExpanded
            ? 'bg-gray-700 hover:bg-gray-800 rotate-180'
            : 'bg-red-600 hover:bg-red-700'
        }`}
        style={!isExpanded ? { animation: 'heartbeat 1.5s ease-in-out infinite' } : {}}
        aria-label="Toggle contact menu"
      >
        {isExpanded ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <Phone className="w-6 h-6 text-white" />
        )}
      </button>
    </div>
  );
};